/**
 * Assets del producto DPS65 · Solar PV & Battery Diagnostic Pro.
 *
 * MAIN_MOCKUP_URL: mockup principal (hero y recuadro de precio). Vacío =
 * se muestra el abanico de tapas diseñado en código (ProductStack).
 * Pegar acá la URL pública del mockup cuando esté listo.
 */
export const MAIN_MOCKUP_URL = ''

/**
 * Capturas reales de páginas (Gamma), formato horizontal 16:10.
 * Vacío = "A look inside" muestra las vistas previas diseñadas en código.
 * Cuando estén los tomos en Gamma, pegar la URL de cada captura.
 */
export const PAGE_IMAGES: Record<
  'card' | 'flowchart' | 'codeColumns' | 'worksheet' | 'guessProve' | 'fieldCard',
  string
> = {
  card: '',
  flowchart: '',
  codeColumns: '',
  worksheet: '',
  guessProve: '',
  fieldCard: '',
}
